import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";

const Spinner = () => (
  <div className="flex justify-center items-center">
    <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12"></div>
  </div>
);

const SignIN = () => {
  const navigate = useNavigate();
  const [userNo, setUserNo] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(true);
  const [loading, setLoading] = useState(false);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "auto", // adjust as needed
      maxHeight: "80vh", // adjust as needed
      overflow: "auto",
      padding: "20px",
      borderRadius: "10px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000, // ensure it overlays other content
    },
  };

  useEffect(() => {
    // Append the script to the document
    const script = document.createElement("script");
    script.src = "https://www.phone.email/sign_in_button_v1.js";
    script.async = true;
    document.body.appendChild(script);

    // Cleanup the script when the component is unmounted
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Define the phoneEmailListener function globally
  useEffect(() => {
    window.phoneEmailListener = (userObj) => {
      const user_json_url = userObj.user_json_url;
      setLoading(true);
      
      // Send user_json_url to your backend
      axios
        .post(`${process.env.REACT_APP_URL}/user/verify`, { user_json_url })
        .then((response) => {
          const { user_phone_number } = response.data;
          setUserNo(user_phone_number);
        })
        .catch((error) => {
          console.error("Error: " + error.message);
        })
        .finally(() => {
          setLoading(false);
        });
    };
  }, []);

  useEffect(() => {
    // Check if user exists or not
    if (userNo) {
      setLoading(true);
      axios
        .get(`${process.env.REACT_APP_URL}/user/userexist`, {
          params: {
            phoneNumber: userNo,
          },
        })
        .then((response) => {
          if (response.data.userExist) {
            const token = response.data.token;
            localStorage.setItem("STITCHD_ID", token);
            navigate("/");
            window.location.reload();
          } else {
            navigate("/userinfo");
          }
        })
        .catch((error) => {
          console.error(
            "Error checking user existence:",
            error.response.data.message
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [userNo, navigate]);

  const closeModal = () => {
    setModalIsOpen(false);
    navigate('/');
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Order Details"
      style={customStyles}
    >
      <div className="font-twentieth-century">
        <div className="flex justify-between">
          <p></p>
          <button
            onClick={closeModal}
            className="text-gray-500 hover:text-gray-700 focus:outline-none text-right"
          >
            <FaTimes size={24} />
          </button>
        </div>
        <div className="flex flex-col items-center justify-center">
          <div className="h-auto w-auto border shadow-sm p-6 bg-gray-100">
            <h2 className="text-2xl font-bold mb-4 text-center">Welcome Back!</h2>
            <p className="mb-2 text-center">Login or Signup to your account</p>
            {loading ? (
              <Spinner />
            ) : (
              <div
                className="pe_signin_button pl-1"
                data-client-id="15521519833135437066"
              ></div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SignIN;
